module.exports = __webpack_public_path__ + "static/media/tutorial-card-1.2f7393a6.png";